import { StepOptions, StepVariable } from '@order/steps/types'

import OptionRecommendedModal from '@order/modals/OptionModals/OptionRecommendedModal'
import { useFocusEffect } from 'expo-router'
import { useCallback, useMemo, useRef, useState } from 'react'
import { Recommendations, RecommendUtils } from 'recommend/RecommendUtils'
import { OptionProps } from './templates/Default/Option/OptionDefault'

const OptionRecommendation = (props: {
  recommendations?: Recommendations
  options: StepOptions
  variable?: StepVariable | null
  OptionComponent?: React.ComponentType<OptionProps>
}) => {
  const { recommendations, options, variable, OptionComponent } = props
  const [open, setOpen] = useState(false)
  const wasShown = useRef(false)

  const recommendedOption = useMemo(() => {
    return RecommendUtils.options.findRecommended(recommendations, options)
  }, [recommendations, options])

  const recommendation = recommendations?.recommend[0]

  const close = useCallback(() => {
    setOpen(false)
  }, [])

  useFocusEffect(
    useCallback(() => {
      if (
        !recommendedOption ||
        !recommendation ||
        !recommendation.option.showRecommendedModal ||
        wasShown.current
      ) {
        return
      }
      setTimeout(() => {
        setOpen(true)
        wasShown.current = true
      }, 0)
    }, [recommendedOption, recommendation])
  )

  if (
    !recommendedOption ||
    !recommendation ||
    !recommendation.option.showRecommendedModal
  ) {
    return null
  }

  return (
    <OptionRecommendedModal
      open={open}
      close={close}
      onAccept={() => {
        close()
        setTimeout(() => {
          recommendedOption.onPress?.()
        }, 0)
      }}
      onDecline={close}
      option={{
        ...recommendedOption,
        options: options.length,
        isRecommended: false, // NOTE: the whole point of this modal is to show recommended option. lets use the recommendation highlight only when displayed next to other options.
      }}
      recommendation={recommendation.option}
      variable={variable}
      OptionComponent={OptionComponent}
    />
  )
}

export default OptionRecommendation
